import userService from '../../services/user.service';
import {
  APPLICATION_REFRESH_DATE,
  APP_INIT_DEFERRED,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  ORGANIZATION_SWITCH,
  OWNERS_UPDATE,
  USERS_MGMT_INVITE_USERS,
  USERS_MGMT_MANAGE_RESTRICTED_WORKSPACES_ACCESS,
} from '../actions';
import { fetchUsers } from '../actions/users-management.actions';

export const onInviteFriendsMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (action.type === USERS_MGMT_INVITE_USERS) {
      dispatch(fetchUsers());
    }
  };

export const usersFetchDataMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_INIT_DEFERRED ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE ||
      action.type === ORGANIZATION_SWITCH ||
      (action.type === OWNERS_UPDATE && action.payload.isUpdate) ||
      action.type === USERS_MGMT_MANAGE_RESTRICTED_WORKSPACES_ACCESS
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(fetchUsers());
    }
  };
export const usersManagementMiddleware = [onInviteFriendsMiddleware, usersFetchDataMiddleware];
